var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBg4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 552,
    viewBox: "0 0 1440 552",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25987_49632)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_25987_49632",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1440,
    height: 552
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1440 552H0V0H1440V552Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_25987_49632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M653.142 -1069.98C665.763 -1094.54 695.906 -1104.22 720.467 -1091.6L1998.45 -434.859C2023.01 -422.237 2032.69 -392.095 2020.06 -367.534L1546.48 554.027C1533.86 578.584 1503.92 588.365 1479.37 575.75C1365.5 517.265 1056.31 358.436 840.651 247.508C625.493 136.838 315.164 -22.5748 201.008 -81.2097C176.441 -93.8287 166.949 -123.878 179.572 -148.443L653.142 -1069.98Z",
    fill: "#DCEEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-290.887 304.469C-278.265 279.908 -248.122 270.23 -223.561 282.853L1150.89 989.224C1175.45 1001.85 1185.12 1031.99 1172.5 1056.55L807.264 1767.24C794.643 1791.79 764.601 1801.52 740.042 1788.9C620.681 1727.58 286.053 1555.66 53.2246 1435.92C-179.058 1316.46 -514.921 1143.9 -634.585 1082.42C-659.151 1069.8 -668.745 1039.7 -656.121 1015.14L-290.887 304.469Z",
    fill: "url(#paint0_linear_25987_49632)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25987_49632",
    x1: 885.502,
    y1: 1347,
    x2: 29.5018,
    y2: 368.497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F2FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F2FD",
    stopOpacity: 0.096144
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25987_49632"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 552,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg4);
export default __webpack_public_path__ + "static/media/bg-4.3f0346afb5c1c640261de2a15e890674.svg";
export { ForwardRef as ReactComponent };